module.exports = __webpack_public_path__ + "img/mudancas-fretes-comercial.9dc3b212.webp";